import { Close as CloseIcon } from "@mui/icons-material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Paper,
  IconButton,
} from "@mui/material";
import Button from "components/common/Button";
import React from "react";

const PaymentDeleteConfirmModal = ({ open, onCancel, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth={"sm"} fullWidth>
      <DialogTitle>
        {"Delete Payment"}
        <IconButton
          aria-label={"close"}
          onClick={onCancel}
          sx={{ position: "absolute", right: 8, top: 8 }}
          size={"small"}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Paper elevation={0} sx={{ padding: "1rem" }}>
          <Typography variant={"body1"} sx={{ mt: 0.5 }}>
            {
              "Are you sure you want to delete this payment? Once deleted this action cannot be undone."
            }
          </Typography>
        </Paper>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onConfirm} color={"error"} sx={{ width: 100 }}>
          {"Delete"}
        </Button>
        <Button onClick={onCancel} color={"secondary"} sx={{ width: 100 }}>
          {"Cancel"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDeleteConfirmModal;
